import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import uk from "./locales/uk/translation.json";
import en from "./locales/en/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      uk: { translation: uk },
      en: { translation: en },
    },
    fallbackLng: "uk",
    supportedLngs: ["uk", "en"],
    detection: {
      // Order: localStorage → browser language → default
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18n_language",
      cacheUserLanguage: true,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
